import { TRootState } from '@/redux/rootReducer';

export const selectModalState = (state: TRootState) => state.modal;
